import { MENU_FLOWS } from "@/constants/global";
import { OrderItem, OrganizationSettings } from "@/types";
import { sanitizeNumber } from "@/utils/numbers";

export const getOrderItemPrice = (dish: OrderItem, skipMultiplication = false): number => {
  const quantity = sanitizeNumber(dish.quantity, 1);
  const price = sanitizeNumber(dish.price);

  let unitPrice = price;

  if (!dish?.settings) {
    return (unitPrice = price);
  }

  dish.settings.forEach((s) => {
    (s?.options ?? []).forEach((o) => {
      const optionPrice = sanitizeNumber(o.price);
      unitPrice += optionPrice;
    });
  });

  if (skipMultiplication) {
    return unitPrice;
  }

  return unitPrice * quantity;
};

export const getOrderDetails = (dish: OrderItem) => {
  if (!dish.settings && !dish.comments) return;

  const settingsText = dish.settings
    ?.map((s) => {
      return `${s.title}: ${s.options?.map((o) => o.title).join(", ")}.`;
    })
    .join(" \n");

  const commentsText = dish.comments ? `Comentario: ${dish.comments}` : "";

  return [settingsText, commentsText].filter(Boolean).join(" ");
};

export const getOrderSubtotal = (dish: OrderItem[]): number => {
  return dish?.reduce((total, item) => {
    return total + getOrderItemPrice(item);
  }, 0);
};

export const getOrderTaxes = (dish: OrderItem[]): number => {
  const fixedTax = 0.15;
  return dish?.reduce((total, item) => {
    return total + getOrderItemPrice(item) * fixedTax;
  }, 0);
};

export const getOrderTips = (dish: OrderItem[]): number => {
  const fixedTip = 0.1;
  const subtotal = getOrderSubtotal(dish);
  return subtotal * fixedTip;
};

export const getServiceFee = (
  flow: MENU_FLOWS,
  settings: OrganizationSettings
): number => {
  const service = settings?.services[flow as keyof typeof settings.services];

  if (!service?.isEnabled || !service?.fee) return 0;

  return sanitizeNumber(service.fee.value) ?? 0;
};

export const getOrderTotal = (dish: OrderItem[], includeTaxes = true, serviceFee = 0): number => {
  const subtotal = getOrderSubtotal(dish);
  const taxes = getOrderTaxes(dish);
  return includeTaxes ? subtotal + taxes + serviceFee : subtotal + serviceFee;
};

export const calculateOrderTotals = (items: OrderItem[], tipPercentage = 0, areTipsIncluded = false, serviceFee = 0) => {
  const subtotal = getOrderSubtotal(items);
  const taxes = getOrderTaxes(items);
  const tips = areTipsIncluded ? subtotal * (tipPercentage / 100) : 0;
  const total = subtotal + taxes + tips + serviceFee;

  return { subtotal, taxes, tips, total };
};



